<input
  type="checkbox"
  [attr.aria-labelledby]="inputId + 'checkbox-label'"
  [attr.id]="inputId"
  [disabled]="disabled"
  [checked]="checked"
  [readOnly]="readOnly"
  test-id="ms-checkbox-input"
  (click)="click()"
/>
<label
  [id]="inputId + 'checkbox-label'"
  [attr.for]="inputId"
  (blur)="blur()"
  (click)="!readOnly"
>
  <ng-content></ng-content>
</label>
